import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";
import { Content, Control, Label, Select } from "rbx";
import { getFilterState } from "../../../utils";
import { ALL_COMPANY_POSTING_PERIODS_QUERY } from "../../../graphql/CompanyPostingPeriods/CompanyPostingPeriods.graphql";
import FilterButtons from "../../../components/FilterButtons";

const CompanyPostingPeriodsPageFilters = ({ onFilter, onClose }) => {
  const [yearSelected, setYearSelected] = useState();

  const today = new Date();

  useEffect(() => {
    const currentFilter = getFilterState("COMPANY_POSTING_PERIOD_FILTERS");

    const year = new Date(
      currentFilter?.PeriodEndDateTime_gte || today
    ).getFullYear();

    setYearSelected(year);
    // eslint-disable-next-line
  }, []);

  const { data, loading } = useQuery(ALL_COMPANY_POSTING_PERIODS_QUERY, {
    variables: {
      orderByMulti: ["PeriodEndDateTime_DESC"]
    },
    fetchPolicy: "network-only"
  });

  const years = useMemo(() => {
    const newYears = [];
    if (data?.CompanyPostingPeriods) {
      data.CompanyPostingPeriods.map(({ PeriodEndDateTime }) => {
        const newDate = new Date(PeriodEndDateTime);
        const year = newDate.getFullYear();
        if (!newYears.some(newYear => newYear === year)) {
          newYears.push(year);
        }
        return PeriodEndDateTime;
      });
    }
    return newYears;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.CompanyPostingPeriods]);

  const handleClose = () =>
    onClose(
      onFilter(
        yearSelected
          ? {
              PeriodEndDateTime_gte: new Date(`01/01/${yearSelected}`).setHours(
                0,
                0,
                0,
                0
              ),
              PeriodEndDateTime_lte: new Date(`12/31/${yearSelected}`).setHours(
                23,
                59,
                59,
                999
              )
            }
          : {}
      )
    );
  const handleCancel = () => onClose();
  const handleReset = () =>
    onClose(
      onFilter({
        PeriodEndDateTime_gte: new Date(
          `01/01/${today.getFullYear()}`
        ).setHours(0, 0, 0, 0),
        PeriodEndDateTime_lte: new Date(
          `12/31/${today.getFullYear()}`
        ).setHours(23, 59, 59, 999)
      })
    );

  return (
    <div style={{ width: 400, margin: "0 auto", padding: 5 }}>
      <Content textAlign="centered">
        <Control>
          <Label>Fiscal Year</Label>
          <Select.Container fullWidth style={{ width: "100%" }}>
            <Select
              disabled={loading}
              name="yearSelected"
              style={{ width: "100%" }}
              value={yearSelected}
              onChange={e => setYearSelected(e.target.value)}
            >
              <Select.Option value="" />
              {years.map((year, i) => (
                <Select.Option key={i} value={year}>
                  {year}
                </Select.Option>
              ))}
            </Select>
          </Select.Container>
        </Control>
      </Content>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
};

CompanyPostingPeriodsPageFilters.propTypes = {
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default CompanyPostingPeriodsPageFilters;
